export default __webpack_public_path__ + "static/media/products-airlockz-cblue-comp.a118f56c.png";